import { apiRequest } from './apiHelper';
import { showServerError, showError } from './toastHelper';


// Admin endpoints
export const adminNotificationsApi = {
  list: async (page = 1, limit = 10) => {
    const params = new URLSearchParams({ page, limit });
    return apiRequest(`/admin/notifications?${params.toString()}`);
  },
  unreadCount: async () => {
    return apiRequest('/admin/notifications/unread-count');
  },
  markRead: async (id) => {
    return apiRequest(`/admin/notifications/${id}/read`, { method: 'PATCH' });
  },
  markAllRead: async () => {
    return apiRequest('/admin/notifications/mark-all-read', { method: 'POST' });
  },
  delete: async (id) => {
    return apiRequest(`/admin/notifications/${id}`, { method: 'DELETE' });
  },
  deleteAll: async () => {
    return apiRequest('/admin/notifications', { method: 'DELETE' });
  }
};

// User endpoints
export const userNotificationsApi = {
  list: async (page = 1, limit = 10) => {
    const params = new URLSearchParams({ page, limit });
    return apiRequest(`/notifications?${params.toString()}`);
  },
  unreadCount: async () => {
    return apiRequest('/notifications/unread-count');
  },
  markRead: async (id) => {
    return apiRequest(`/notifications/${id}/read`, { method: 'PATCH' });
  },
  markAllRead: async () => {
    return apiRequest('/notifications/mark-all-read', { method: 'POST' });
  }
};

// Common error handler for consumers
export const handleNotificationError = (error, fallbackMessage) => {
  if (error?.isAuthError) return;
  if (error?.apiError) {
    showServerError();
  } else {
    showError(error?.data?.message || error?.message || fallbackMessage);
  }
};

/**
 * Trigger instant notification refresh in AdminLayout
 * Call this after any admin action that might create a notification
 * (e.g., order creation, shipment creation, etc.)
 */
export const triggerNotificationRefresh = () => {
  window.dispatchEvent(new CustomEvent('refreshNotifications'));
};
